module.exports = __webpack_public_path__ + "assets/0f5d7c0b5e67c059420c744fdf333105.mp3";